import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Confirmation from "./component";
import {
  createGuestUserWithoutEmail,
  downloadAssessmentResult,
  updateConfimation,
} from "./actions";
import {
  GetUserById,
  isGuestOrPremiumUser,
  updateUser,
  createGuestUser,
  getGuestUser,
  getBilling,
} from "../settings/actions";
import { viewAssessmentReport } from "../personality-report/actions";
import {
  saveRelationshipCompatibilityResult,
  saveUserAssessmentResultMaps,
} from "../quiz/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      UpdateConfimationConnect: updateConfimation,
      DownloadAssessmentResultConnect: downloadAssessmentResult,

      ViewAssessmentReportConnect: viewAssessmentReport,
      GetUserByIdConnect: GetUserById,
      updateUserConnect: updateUser,
      createGuestUserWithoutEmailConnect: createGuestUserWithoutEmail,
      GuestUserChangesConnect: createGuestUser,
      GetGuestUserConnect: getGuestUser,
      GetBillingConnect: getBilling,
      saveRelationshipCompatibilityResultConnect:
        saveRelationshipCompatibilityResult,
      saveUserAssessmentResultMapsConnect: saveUserAssessmentResultMaps,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
